import StyleList from './style_list_config';


//生成一个列的类
class OneRow {
  constructor({
                theme_eare_name = '',
                name = 'layout_row',
                name_ = 'layout_row',
                widgets_id,
                children = [],
                rowType,
                isNewRow,
                newType,
                contentWidthType,
                adaptBackgroundIsOpen,
                fixed_background_isOpen,
                data = JSON.parse(JSON.stringify(StyleList[name]))
              }) {
    this.name = name;
    this.name_ = name_;
    this.pid = 0;
    this.widgets_id = widgets_id;
    this.data = data;
    this.theme_eare_name = theme_eare_name;

    this.rowType = rowType;
    this.children = children;
    this.isShow = true;
    this.isEdit = false;


    isNewRow && (this.isNewRow = isNewRow);
    newType && (this.newType = newType);

    // 内容宽度
    this.contentWidthType = contentWidthType || 'normal'
    this.adaptBackgroundIsOpen = adaptBackgroundIsOpen || 'true'
    this.fixed_background_isOpen = fixed_background_isOpen || 'false'
  }
}

export default OneRow;



// WEBPACK FOOTER //
// ./src/base/one_row.js